import type {FullName} from '../typedef';

type GetInitials = (name: FullName) => string;

export const getInitials: GetInitials = name => {
    const firstName = name.firstName[0];
    const lastName = name.lastName.split(' ');

    return `${firstName[0]}${lastName[lastName.length - 1][0]}`.toUpperCase();
};
